import { render, staticRenderFns } from "./CostItemSingle.vue?vue&type=template&id=fdd35f4e&scoped=true&"
import script from "./CostItemSingle.vue?vue&type=script&lang=js&"
export * from "./CostItemSingle.vue?vue&type=script&lang=js&"
import style0 from "./CostItemSingle.vue?vue&type=style&index=0&id=fdd35f4e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdd35f4e",
  null
  
)

export default component.exports